import { render, staticRenderFns } from "./VisitorTable.vue?vue&type=template&id=0fa8c2da"
import script from "./VisitorTable.vue?vue&type=script&lang=js"
export * from "./VisitorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports